import { Routes } from '@angular/router';
import { NewslettersComponent } from './newsletters.component';

export default [
    {
        path     : '',
        component: NewslettersComponent,
    },
    
] as Routes;
